import { render } from "./details.vue?vue&type=template&id=b9078ef0&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=b9078ef0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b9078ef0"

export default script